module.exports = __webpack_public_path__ + "media/jamaica.eb4e60d5.jpg";